// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `angular-cli.json`.

/** environment */
export const environment = {
  production: true,
  stubMode: false,
  configPath: '/simplicity/form-center/js/config/',
  simplicityAssets: '/simplicity/assets/',
  svgIcons: '/simplicity/simplicity-smaller/svgs/svgdefs.svg',
  featuresConfigPath: '/simplicity/form-center/js/config/features.json',
  cmsWordingPath: '/wording/form-center/',
  cmsConfigPath: '/config/form-center/',
  cmsErrorMessagesPath: '/api-static/errormessages/',
  cmsCommonWording: '/config/deWording-core.json',
  cmsTariffConfigPath: '/api-static/ecare-tariffcards/',
  cmsCPMconfigPath: '/simplicity/form-center/config/',
  baseUrlDxl: '/api',
  baseUrlDxlTest: 'dxl.test',
  baseUrlDxlPreProd: 'dxl.preprod',
  baseUrlDxlTestFullPath: 'https://dxl.test.api.vodafone.de',
  baseUrlDxlPreProdFullPath: 'https://dxl.preprod.api.vodafone.de',
  baseUrlDxlProd: 'https://api.vodafone.de',

};
